import { Prop } from '@typegoose/typegoose'

export class PasskeyAuth {
  @Prop({ type: String })
  credentialId: string // Base64URL encoded credential ID (indexed, unique per user)

  @Prop({ type: String })
  publicKey: string // Base64URL encoded public key (CBOR format)

  @Prop({ type: Number })
  counter: number // Signature counter for replay protection

  @Prop({ type: String })
  name: string // User-friendly name (e.g., "My Laptop")

  @Prop({ type: Date })
  createdAt: Date

  @Prop({ type: Date })
  lastUsedAt: Date // Updated on each successful authentication
}